import { LocalizedAttributesValue } from 'src/generated/operations.ts';

export const DashValue: LocalizedAttributesValue = {
    raw: ['-'],
    localized: ['-'],
};
